import type { PreviewModalState } from "./preview-modal.type";

import { atom } from "jotai";

export const previewModalAtom = atom<PreviewModalState>({ visible: false });
